import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  PayState,
  PayParams,
  PayApiResponse,
  PayPerDayApiResponse,
} from "./PayType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncPay: any = createAsyncThunk<PayParams, PayApiResponse>(
  "Pay/get",
  async () => {
    const response = await axiosSettings.get("api-admin/payment/pay-total");

    return response.data;
  }
);

//直近7日間の登録者数
export const fetchAsyncPayPerDay: any = createAsyncThunk<
  PayPerDayApiResponse,
  PayParams
>("PayPerDay/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/payment/pay-per-day?page=${page}`
  );
  return { ...response.data, page };
});

const initialState: PayState = {
  pay: null,
  payPerDay: null,
  updatedTime: "",
  loading: false,
  error: "",
};

const PaySlice = createSlice({
  name: "Pay",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    //登録者数
    builder.addCase(fetchAsyncPay.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.pay = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data.result;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncPay.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncPay.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //直近7日間の登録者数
    builder.addCase(fetchAsyncPayPerDay.fulfilled, (state, action) => {
      state.payPerDay = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncPayPerDay.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncPayPerDay.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
  },
});

export const PayInfo = (state: RootState) => state.Pay.pay;
export const payPerDay = (state: RootState) => state.Pay.payPerDay;
export const PayError = (state: RootState) => state.Pay.error;
export const PayLoading = (state: RootState) => state.Pay.loading;
export const PayUpdatedTime = (state: RootState) => state.Pay.updatedTime;
export default PaySlice.reducer;
